import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Nav, Navbar, Offcanvas } from 'react-bootstrap';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { BiPhoneCall } from 'react-icons/bi'; // Import React Icons
import logo from '../Components/img/mind care.png';

const Header = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleShow = () => setShowOffcanvas(true);
  const handleClose = () => setShowOffcanvas(false);

  return (
    <>
      <div style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
        <Navbar expand="lg" className="bg-white shadow fw-bold">
          <Container>
            <Navbar.Brand className="text-start ms-0">
              <img
                src={logo}
                alt="logo"
                className="logomd"
                style={{
                  maxWidth: '300px',
                  height: 'auto',
                }}
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="offcanvas-navbar" onClick={handleShow} />
            <Navbar.Offcanvas
              id="offcanvas-navbar"
              aria-labelledby="offcanvas-navbar-label"
              placement="start"
              show={showOffcanvas}
              onHide={handleClose}
              className="text-black"
              style={{ background: '#13baab' }}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvas-navbar-label">Menu</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="me-auto">
                  <Nav.Link as={Link} to="/" className="mx-1 text-center hover:underline rounded-md" onClick={handleClose}>
                    HOME
                  </Nav.Link>
                  <Nav.Link as={Link} to="/About" className="mx-2 hover:underline text-center rounded-md" onClick={handleClose}>
                    ABOUT
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Treatment" className="mx-2 hover:underline text-center rounded-md" onClick={handleClose}>
                    TREATMENT
                  </Nav.Link>
                  <NavDropdown title="GALLERY" id="basic-nav-dropdown" className="mx-3 text-center hover:underline">
                    <NavDropdown.Item as={Link} to="/Social_work" className="hover:underline py-2">
                      Social Work
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/Print_media" className="hover:underline py-2">
                      Print Media
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/Videos" className="hover:underline py-2">
                      Videos
                    </NavDropdown.Item>
                  </NavDropdown>
                  <Nav.Link as={Link} to="/Blog" className="mx-2 hover:underline text-center rounded-md" onClick={handleClose}>
                    BLOG
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Testimonial" className="mx-2 hover:underline text-center rounded-md" onClick={handleClose}>
                    TESTIMONIAL
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Contact" className="mx-2 hover:underline text-center rounded-md" onClick={handleClose}>
                    CONTACT
                  </Nav.Link>

                  {/* Call Icon and Phone Number with React Icons */}
                  <Nav.Link as={Link} to="/Contact" onClick={handleClose} className="text-center w-100">
  <span className="d-flex align-items-center justify-content-center gap-1 text-dark fw-bold text-decoration-none">
    <BiPhoneCall size={20} />+919579542771 <br></br>
    +919607899660
  </span>
</Nav.Link>



                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Header;
